

export const coeffCTr = {           // from Phoenix Conveyor Belts
    cotton: 80,
    polyester: 108,
    polyamide: 90,
    steelcord: 145,
};

// export const minPulleyDia = ;
// export const minPulleyDiaDataForFabricBelt = [
//     { DTr: 2000, loadFactors: { '100%': { A: 2200, B: 2000, C: 1400 }, '60%': { A: 2000, B: 1600, C: 1250 }, '30%': { A: 1600, B: 1250, C: 1000 }, '30%-': { A: 1250, B: 1250, C: 1000 } } },
//     { DTr: 1800, loadFactors: { '100%': { A: 2000, B: 1800, C: 1250 }, '60%': { A: 1800, B: 1400, C: 1250 }, '30%': { A: 1600, B: 1250, C: 1000 }, '30%-': { A: 1250, B: 1250, C: 1000 } } },
//     { DTr: 1600, loadFactors: { '100%': { A: 1800, B: 1600, C: 1250 }, '60%': { A: 1600, B: 1250, C: 1000 }, '30%': { A: 1250, B: 1000, C: 800 }, '30%-': { A: 1000, B: 1000, C: 800 } } },
//     { DTr: 1400, loadFactors: { '100%': { A: 1600, B: 1400, C: 1000 }, '60%': { A: 1400, B: 1250, C: 1000 }, '30%': { A: 1250, B: 1000, C: 800 }, '30%-': { A: 1000, B: 1000, C: 800 } } },
//     { DTr: 1250, loadFactors: { '100%': { A: 1400, B: 1250, C: 1000 }, '60%': { A: 1250, B: 1000, C: 800 }, '30%': { A: 1000, B: 800, C: 630 }, '30%-': { A: 800, B: 800, C: 630 } } },
//     { DTr: 1000, loadFactors: { '100%': { A: 1250, B: 1000, C: 800 }, '60%': { A: 1000, B: 800, C: 630 }, '30%': { A: 800, B: 630, C: 500 }, '30%-': { A: 630, B: 630, C: 500 } } },
//     { DTr: 800, loadFactors: { '100%': { A: 1000, B: 800, C: 630 }, '60%': { A: 800, B: 630, C: 500 }, '30%': { A: 630, B: 500, C: 400 }, '30%-': { A: 500, B: 500, C: 400 } } },
//     { DTr: 630, loadFactors: { '100%': { A: 800, B: 630, C: 500 }, '60%': { A: 630, B: 500, C: 400 }, '30%': { A: 500, B: 400, C: 315 }, '30%-': { A: 400, B: 400, C: 315 } } },
//     { DTr: 500, loadFactors: { '100%': { A: 630, B: 500, C: 400 }, '60%': { A: 500, B: 400, C: 315 }, '30%': { A: 400, B: 315, C: 250 }, '30%-': { A: 315, B: 315, C: 250 } } },
//     { DTr: 400, loadFactors: { '100%': { A: 500, B: 400, C: 315 }, '60%': { A: 400, B: 315, C: 250 }, '30%': { A: 315, B: 250, C: 200 }, '30%-': { A: 250, B: 250, C: 200 } } },
//     { DTr: 315, loadFactors: { '100%': { A: 400, B: 315, C: 250 }, '60%': { A: 315, B: 250, C: 200 }, '30%': { A: 250, B: 200, C: 160 }, '30%-': { A: 200, B: 200, C: 160 } } },
//     { DTr: 250, loadFactors: { '100%': { A: 315, B: 250, C: 200 }, '60%': { A: 250, B: 200, C: 160 }, '30%': { A: 200, B: 160, C: 125 }, '30%-': { A: 160, B: 160, C: 125 } } },
//     { DTr: 200, loadFactors: { '100%': { A: 250, B: 200, C: 160 }, '60%': { A: 200, B: 160, C: 125 }, '30%': { A: 160, B: 125, C: 100 }, '30%-': { A: 125, B: 125, C: 100 } } },
//     { DTr: 160, loadFactors: { '100%': { A: 200, B: 160, C: 125 }, '60%': { A: 160, B: 125, C: 100 }, '30%': { A: 125, B: 100, C: 100 }, '30%-': { A: 100, B: 100, C: 100 } } },
//     { DTr: 125, loadFactors: { '100%': { A: 160, B: 125, C: 100 }, '60%': { A: 125, B: 100, C: 100 }, '30%': { A: 100, B: 100, C: 100 }, '30%-': { A: 100, B: 100, C: 100 } } },
//     { DTr: 100, loadFactors: { '100%': { A: 125, B: 100, C: 100 }, '60%': { A: 100, B: 100, C: 100 }, '30%': { A: 100, B: 100, C: 100 }, '30%-': { A: 100, B: 100, C: 100 } } },
//     // { DTr: 360, loadFactors: { '100%': { A: 400, B: 800, C: 630 }, '60%': { A: 500, B: 630, C: 500 }, '30%': { A: 400, B: 500, C: 400 }, '30%-': { A: 315, B: 400, C: 400 } } },
// ];


export const minPulleyDiaForFabric = [  // 상기 데이터에서 사용하지 않는 100% 초과 부분을 제거함.
    { DTr: 100, loadFactors: { '100%': { A: 100, B: 100, C: 100 }, '60%': { A: 100, B: 100, C: 100 }, '30%': { A: 100, B: 100, C: 100 } } },
    { DTr: 125, loadFactors: { '100%': { A: 125, B: 100, C: 100 }, '60%': { A: 100, B: 100, C: 100 }, '30%': { A: 100, B: 100, C: 100 } } },
    { DTr: 160, loadFactors: { '100%': { A: 160, B: 125, C: 100 }, '60%': { A: 125, B: 100, C: 100 }, '30%': { A: 100, B: 100, C: 100 } } },
    { DTr: 200, loadFactors: { '100%': { A: 200, B: 160, C: 125 }, '60%': { A: 160, B: 125, C: 100 }, '30%': { A: 125, B: 125, C: 100 } } },
    { DTr: 250, loadFactors: { '100%': { A: 250, B: 200, C: 160 }, '60%': { A: 200, B: 160, C: 125 }, '30%': { A: 160, B: 160, C: 125 } } },
    { DTr: 315, loadFactors: { '100%': { A: 315, B: 250, C: 200 }, '60%': { A: 250, B: 200, C: 160 }, '30%': { A: 200, B: 200, C: 160 } } },
    { DTr: 400, loadFactors: { '100%': { A: 400, B: 315, C: 250 }, '60%': { A: 315, B: 250, C: 200 }, '30%': { A: 250, B: 250, C: 200 } } },
    { DTr: 500, loadFactors: { '100%': { A: 500, B: 400, C: 315 }, '60%': { A: 400, B: 315, C: 250 }, '30%': { A: 315, B: 315, C: 250 } } },
    { DTr: 630, loadFactors: { '100%': { A: 630, B: 500, C: 400 }, '60%': { A: 500, B: 400, C: 315 }, '30%': { A: 400, B: 400, C: 315 } } },
    { DTr: 800, loadFactors: { '100%': { A: 800, B: 630, C: 500 }, '60%': { A: 630, B: 500, C: 400 }, '30%': { A: 500, B: 500, C: 400 } } },
    { DTr: 1000, loadFactors: { '100%': { A: 1000, B: 800, C: 630 }, '60%': { A: 800, B: 630, C: 500 }, '30%': { A: 630, B: 630, C: 500 } } },
    { DTr: 1250, loadFactors: { '100%': { A: 1250, B: 1000, C: 800 }, '60%': { A: 1000, B: 800, C: 630 }, '30%': { A: 800, B: 800, C: 630 } } },
    { DTr: 1400, loadFactors: { '100%': { A: 1400, B: 1250, C: 1000 }, '60%': { A: 1250, B: 1000, C: 800 }, '30%': { A: 1000, B: 1000, C: 800 } } },
    { DTr: 1600, loadFactors: { '100%': { A: 1600, B: 1250, C: 1000 }, '60%': { A: 1250, B: 1000, C: 800 }, '30%': { A: 1000, B: 1000, C: 800 } } },
    { DTr: 1800, loadFactors: { '100%': { A: 1800, B: 1400, C: 1250 }, '60%': { A: 1600, B: 1250, C: 1000 }, '30%': { A: 1250, B: 1250, C: 1000 } } },
    { DTr: 2000, loadFactors: { '100%': { A: 2000, B: 1600, C: 1250 }, '60%': { A: 1600, B: 1250, C: 1000 }, '30%': { A: 1250, B: 1250, C: 1000 } } },
];

export const minPulleyDiaForSteelcord = [
    { rating: 400, loadFactors: { '100%': { A: 400, B: 315, C: 250 }, '60%': { A: 315, B: 250, C: 250 }, '30%': { A: 250, B: 200, C: 200 } } },
    { rating: 500, loadFactors: { '100%': { A: 500, B: 400, C: 315 }, '60%': { A: 400, B: 315, C: 250 }, '30%': { A: 315, B: 250, C: 200 } } },
    { rating: 630, loadFactors: { '100%': { A: 500, B: 400, C: 315 }, '60%': { A: 400, B: 315, C: 250 }, '30%': { A: 315, B: 250, C: 200 } } },
    { rating: 800, loadFactors: { '100%': { A: 630, B: 500, C: 400 }, '60%': { A: 500, B: 400, C: 315 }, '30%': { A: 400, B: 315, C: 250 } } },
    { rating: 1000, loadFactors: { '100%': { A: 800, B: 630, C: 500 }, '60%': { A: 630, B: 500, C: 400 }, '30%': { A: 500, B: 400, C: 315 } } },
    { rating: 1250, loadFactors: { '100%': { A: 800, B: 630, C: 500 }, '60%': { A: 630, B: 500, C: 400 }, '30%': { A: 500, B: 400, C: 315 } } },
    { rating: 1600, loadFactors: { '100%': { A: 1000, B: 800, C: 500 }, '60%': { A: 800, B: 630, C: 500 }, '30%': { A: 630, B: 500, C: 400 } } },
    { rating: 1800, loadFactors: { '100%': { A: 1000, B: 800, C: 500 }, '60%': { A: 800, B: 630, C: 500 }, '30%': { A: 630, B: 500, C: 400 } } },
    { rating: 2000, loadFactors: { '100%': { A: 1000, B: 800, C: 500 }, '60%': { A: 800, B: 630, C: 500 }, '30%': { A: 630, B: 500, C: 400 } } },
    { rating: 2500, loadFactors: { '100%': { A: 1250, B: 1000, C: 630 }, '60%': { A: 1000, B: 800, C: 500 }, '30%': { A: 800, B: 630, C: 500 } } },
    { rating: 3150, loadFactors: { '100%': { A: 1250, B: 1000, C: 630 }, '60%': { A: 1000, B: 800, C: 630 }, '30%': { A: 800, B: 630, C: 500} } },
    { rating: 3500, loadFactors: { '100%': { A: 1250, B: 1000, C: 630 }, '60%': { A: 1000, B: 800, C: 630 }, '30%': { A: 800, B: 630, C: 500 } } },
    { rating: 4000, loadFactors: { '100%': { A: 1400, B: 1250, C: 800 }, '60%': { A: 1250, B: 1000, C: 800 }, '30%': { A: 1000, B: 800, C: 630 } } },
    { rating: 4500, loadFactors: { '100%': { A: 1400, B: 1250, C: 800 }, '60%': { A: 1250, B: 1000, C: 800 }, '30%': { A: 1000, B: 800, C: 630 } } },
    { rating: 5000, loadFactors: { '100%': { A: 1600, B: 1400, C: 1000 }, '60%': { A: 1400, B: 1250, C: 800 }, '30%': { A: 1250, B: 1000, C: 630 } } },
    { rating: 5400, loadFactors: { '100%': { A: 1600, B: 1400, C: 1000 }, '60%': { A: 1400, B: 1250, C: 800 }, '30%': { A: 1250, B: 1000, C: 630 } } },
    { rating: 6300, loadFactors: { '100%': { A: 1800, B: 1600, C: 1250 }, '60%': { A: 1600, B: 1400, C: 1000 }, '30%': { A: 1400, B: 1250, C: 800 } } },
    { rating: 7500, loadFactors: { '100%': { A: 2000, B: 1600, C: 1250 }, '60%': { A: 1600, B: 1400, C: 1000 }, '30%': { A: 1400, B: 1250, C: 800 } } },
];


export const standardDimensionOfPulley = [
    {
        beltWidth: 400,         // mm
        brgDistance: {          // L
            drive: 90,          // cm
            nonDrive: 80,       // cm
        },
        webDistance: 40,       // L1, cm
        momentArm: 25,         // L2, cm
    },
    {
        beltWidth: 450,
        brgDistance: {
            drive: 95,
            nonDrive: 85,
        },
        webDistance: 45,
        momentArm: 25,       
    },
    {
        beltWidth: 500,
        brgDistance: {
            drive: 100,
            nonDrive: 90,
        },
        webDistance: 50,
        momentArm: 25,       
    },
    {
        beltWidth: 600,
        brgDistance: {
            drive: 110,
            nonDrive: 100,
        },
        webDistance: 60,
        momentArm: 25,       
    },
    {
        beltWidth: 750,
        brgDistance: {
            drive: 135,
            nonDrive: 125,
        },
        webDistance: 75,
        momentArm: 30,       
    },
    {
        beltWidth: 900,
        brgDistance: {
            drive: 150,
            nonDrive: 140,
        },
        webDistance: 90,
        momentArm: 30,       
    },
    {
        beltWidth: 1050,
        brgDistance: {
            drive: 175,
            nonDrive: 165,
        },
        webDistance: 105,
        momentArm: 35,       
    },
    {
        beltWidth: 1200,
        brgDistance: {
            drive: 195,
            nonDrive: 185,
        },
        webDistance: 120,
        momentArm: 37.5,       
    },
    {
        beltWidth: 1400,
        brgDistance: {
            drive: 225,
            nonDrive: 210,
        },
        webDistance: 140,
        momentArm: 40,       
    },
    {
        beltWidth: 1600,
        brgDistance: {
            drive: 240,
            nonDrive: 230,
        },
        webDistance: 160,
        momentArm: 42.5,       
    },
    {
        beltWidth: 1800,
        brgDistance: {
            drive: 270,
            nonDrive: 260,
        },
        webDistance: 180,
        momentArm: 45,       
    },
    {
        beltWidth: 2000,
        brgDistance: {
            drive: 290,
            nonDrive: 280,
        },
        webDistance: 200,
        momentArm: 45,       
    },
    {
        beltWidth: 2200,
        brgDistance: {
            drive: 310,
            nonDrive: 300,
        },
        webDistance: 210,
        momentArm: 50,       
    },
]

export const standardPulleyDia = [
    318, 350, 401, 453, 502, 603, 620, 650, 700, 720, 750, 760, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400
];

export const getPulleyDimensions = (beltWidth, isDrive) => {
    const selected = standardDimensionOfPulley.find(obj => obj.beltWidth === Number(beltWidth));
    const type = isDrive ? 'drive' : 'nonDrive';

    // [Bearing Center Distance, Web Distance, Moment Arm Length]를 리턴함
    return [selected.brgDistance[type], selected.webDistance, selected.momentArm];
}

export const getShaftDia = (resultantForce, torque, eccentricFactor, beltWidth, isDrive ) => {
    /* 작용력의 계산 */
    const U = parseFloat(resultantForce) * parseFloat(eccentricFactor) / 2;
    /* 벨트폭을 가져와서 data로부터 불러오자. defendency를 좀 더 간략화 하기 위해 */
    const [L, L1, L2] = getPulleyDimensions(beltWidth, isDrive);
    /* Max Moment 계산 */
    const maxMoment = Math.ceil(U * L2);
    /* Torque 계산 */

    

    /* By Stress */
    const M = maxMoment;
    const T = parseFloat(torque || 0);
    const Ct = 1.0;
    const Cm = 1.5;
    const Sy = 22000;   // N/cm2
    const Ss = 0.75 * 0.9 * 0.3 * Sy;       // keyed shaft
    const _shaftDiaByStress = (16/Math.PI/Ss*Math.sqrt((Ct*T)**2 + (Cm*M)**2))**(1/3);
    const diaByStress = Math.round(_shaftDiaByStress * 10) / 10;

    /* By Deflection */
    const theta = 7;    // minute
    const E = 205000 * 100;   // N/cm2
    const I = 3440 * (U * L1 * L2) / (2 * E * theta);
    const _shaftDiaByDeflection = (64 * I / Math.PI)**(1/4);
    const diaByDeflection = Math.round(_shaftDiaByDeflection * 10) / 10;

    /* Selection */
    const diaCalculated = Math.ceil(Math.max(_shaftDiaByStress, _shaftDiaByDeflection) / 0.5) * 0.5;     // 0.5단위 반올림

    return [
        L,      // brgDistance
        L1,     // webDistance
        L2,     // momentArm
        maxMoment,
        diaByStress,
        diaByDeflection,
        diaCalculated,
    ];
};

export const getPulleyWeight = (isDrive, beltWidth, hubDiaSelected, brgDistance, webDistance, diaSelected, laggingThick) => {
    const BW = Number(beltWidth);               // mm
    const ds = Number(hubDiaSelected) * 10;     // cm -> mm. Hub 내경 (Shaft Dia. @ hub)
    const db = (1.75) * ds;                      // mm. Hub 외경
    const lb = (1.5) * ds;                      // mm. Hub 길이

    const L = Number(brgDistance) * 10;         // cm -> mm
    const L1 = Number(webDistance) * 10;        // cm -> mm
    const D = Number(diaSelected);              // mm. Selected Pulley Dia.
    const ts = (0.04) * D;                      // mm. Shell Thickness는 4% of Pulley Dia Selected
    const td = ts;                              // mm. End Disc 두께는 Shell 두께와 같은 것으로 가정.
    const Di = D - 2 * ts;                      // mm
    const t = Number(laggingThick);             // mm

    const Lshell = BW > 1050 ? BW + 150 : BW + 100;     // 벨트폭 1050이하는 100, 초과는 150
    const Lshaft = isDrive ? L + 2*400 : L + 2*200;     // Shaft 전체 길이는 drive의 경우 +800, nonDrive의 경우 +400


    const shaftWeight = Math.PI / 4 * (ds)**2 * (Lshaft) * (7.85 * 10**(-6));
    const bossWeight = (2) * Math.PI * (db**2 - ds**2)/4 * lb * (7.85 * 10**(-6));
    const shellWeight = Math.PI * (D**2 - Di**2)/4 * Lshell * (7.85 * 10**(-6));
    const endDiscWeight = (2) * Math.PI * (Di**2 - db**2)/4 * td * (7.85 * 10**(-6));
    const laggingWeight = Math.PI * ((D + t)**2 - D**2)/4 * Lshell * (1.25 * 10**(-6));

    const weight = (shaftWeight + bossWeight + shellWeight + laggingWeight + endDiscWeight);

    return Math.ceil(weight);

} 

export const getMinPulleyDia = (beltWidth, hubDiaSelected, pulleyTypeCategory) => {
    if (!hubDiaSelected) return [0, 0];

    const BW = Number(beltWidth);               // mm

    // By HubDia
    const ds = Number(hubDiaSelected) * 10;     // cm => mm
    const db = (1.75) * ds;

    const minPulleyDiaByHubDia = Math.ceil(db + (2) * (75) + (2) * (0.2) * ds);

    // By Ratio
    const Lshell = BW > 1050 ? BW + 150 : BW + 100;     // 벨트폭 1050이하는 100, 초과는 150

    let minPulleyDiaByRatio
    if (pulleyTypeCategory === 'A') {
        minPulleyDiaByRatio = Math.ceil(Lshell / 2.5);
    } else if (pulleyTypeCategory === 'B') {
        minPulleyDiaByRatio = Math.ceil(Lshell / 3.0);
    } else {
        minPulleyDiaByRatio = Math.ceil(Lshell / 3.5);
    }

    return [minPulleyDiaByHubDia, minPulleyDiaByRatio];
}
